/* nydo fixes – Shop Health Monitor (F01, F12). Safe to remove once fixed in sections/sample.liquid. */
(function () {
  // F01: the fabric-sample page refreshes the cart drawer with $('#CartDrawer').replaceWith(<whole section HTML>).
  // jQuery then re-runs cart.js / gift-wrapping.js ("Identifier 'CartDrawer' has already been declared")
  // and nests a second cart-drawer section. Keep only the <cart-drawer> element and drop its scripts.
  function patchJQuery($) {
    if (!$ || $.__nydoDrawerFix) return;
    $.__nydoDrawerFix = true;
    var original = $.fn.replaceWith;
    $.fn.replaceWith = function (value) {
      var el = this.length === 1 ? this[0] : null;
      if (el && el.id === 'CartDrawer' && typeof value === 'string' && value.indexOf('<cart-drawer') !== -1) {
        var fresh = new DOMParser().parseFromString(value, 'text/html').getElementById('CartDrawer');
        if (fresh) {
          el.innerHTML = fresh.innerHTML; // update in place: scripts are not re-run, no nested section
          return this;
        }
      }
      return original.apply(this, arguments);
    };
  }
  if (window.jQuery) patchJQuery(window.jQuery);
  else document.addEventListener('DOMContentLoaded', function () { patchJQuery(window.jQuery); });

  // F12: the fabric-sample sticky button is hard-coded to "Checkout". Use the shop's own translation.
  var label = window.NYDO_CHECKOUT_LABEL;
  if (!label) return;
  function fix(btn) { if (btn.textContent.trim() === 'Checkout') btn.textContent = label; }
  function watch() {
    document.querySelectorAll('.ssc-order-btn').forEach(function (btn) {
      fix(btn);
      new MutationObserver(function () { fix(btn); }).observe(btn, { childList: true, characterData: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
